<script setup lang="ts">
withDefaults(defineProps<{ variant?: 'object' | 'participant' }>(), {
  variant: 'object',
});
</script>

<template>
  <article :class="['search-result-card', `search-result-card--${variant}`]">
    <div class="search-result-card__media" data-part="media"><slot name="media" /></div>
    <div class="search-result-card__main" data-part="main"><slot /></div>
    <aside class="search-result-card__aside" data-part="aside"><slot name="aside" /></aside>
  </article>
</template>

<style scoped>
.search-result-card {
  display: grid;
  min-width: 0;
  width: 100%;
  color: var(--palette-black);
  background: var(--palette-white);
  border-radius: var(--border-radius-xl);
}

.search-result-card--object {
  --participant-summary-padding-top: 11px;
  --participant-summary-photo-size: 36px;

  grid-template-columns: 200px minmax(0, 1fr) 208px;
  gap: 20px;
  padding: 20px 24px;
}

.search-result-card--participant {
  grid-template-columns: minmax(260px, 0.85fr) minmax(0, 1fr) 240px;
  align-items: start;
  gap: var(--spacing-5xl);
  padding: var(--spacing-3xl);
}

.search-result-card__media,
.search-result-card__main,
.search-result-card__aside {
  min-width: 0;
}

.search-result-card__aside {
  display: flex;
  flex-direction: column;
}

.search-result-card--object .search-result-card__aside {
  align-self: stretch;
  padding-left: 20px;
  border-left: 1px solid var(--palette-gray-100);
}

@media (max-width: 1180px) {
  .search-result-card--object {
    grid-template-columns: 180px minmax(0, 1fr) 180px;
    padding: var(--spacing-4xl);
  }
}

@media (max-width: 1100px) {
  .search-result-card--object {
    --participant-summary-padding-top: 0px;
    --participant-summary-photo-size: 40px;

    grid-template-columns: 180px minmax(0, 1fr);
  }

  .search-result-card--object .search-result-card__aside {
    grid-column: 1 / -1;
    flex-direction: row;
    align-items: center;
    gap: var(--spacing-xl);
    padding-top: var(--spacing-xl);
    padding-left: 0;
    border-top: 1px solid var(--palette-gray-100);
    border-left: 0;
  }

  .search-result-card--participant {
    grid-template-columns: minmax(240px, 0.8fr) minmax(0, 1fr);
  }

  .search-result-card--participant .search-result-card__aside {
    grid-column: 1 / -1;
  }
}

@media (max-width: 755px) {
  .search-result-card--object,
  .search-result-card--participant {
    grid-template-columns: minmax(0, 1fr);
    gap: var(--spacing-xl);
    padding: var(--spacing-xl);
  }

  .search-result-card--object .search-result-card__aside,
  .search-result-card--participant .search-result-card__aside {
    grid-column: auto;
    flex-direction: column;
    align-items: stretch;
  }
}
</style>
